import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calculator } from "lucide-react";
import {
  BooleanInput,
  Create,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../../common";

const typeChoices = [
  { id: "earning", name: "Earning" },
  { id: "deduction", name: "Deduction" },
];
// "formula" is a valid DB value but has no form to define a formula, so
// fn_process_payroll treats it identically to "fixed" — not offered here.
const calculationChoices = [
  { id: "fixed", name: "Fixed" },
  { id: "percent_of_basic", name: "Percent of Basic" },
];

export const PayrollComponentCreate = () => (
  <Create title="Create Payroll Component">
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <Calculator className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">New Payroll Component</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput source="code" label="Component Code" />
            <TextInput source="name" label="Component Name" />
            <SelectInput source="type" choices={typeChoices} defaultValue="earning" />
            <SelectInput
              source="calculation"
              choices={calculationChoices}
              defaultValue="fixed"
            />
            <NumberInput source="value" defaultValue={0} label="Value / Percentage" />
            <NumberInput source="sort_order" defaultValue={0} label="Display Order" />
          </div>
          <div className="mt-4">
            <BooleanInput source="taxable" defaultValue label="Is Taxable?" />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);
